import { Card, CardContent } from '@mui/material';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { FileText, Eye, EyeOff } from 'lucide-react';
import { useNavigate } from "react-router-dom";
export default function Register() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [confirmpassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const [showCPassword, setShowCPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    const toggleCPasswordVisibility = () => {
        setShowCPassword(!showCPassword);
    };

    const handleRegister = async (e) => {
        e.preventDefault();

        // Trim inputs to avoid spaces-only submissions
        const trimmedEmail = email.trim();
        const trimmedName = name.trim();
        const trimmedPassword = password.trim();
        const trimmedConfirmPassword = confirmpassword.trim();

        // Name validation (letters and spaces, min 2 characters)
        const nameRegex = /^[a-zA-Z ]{2,}$/;
        if (!nameRegex.test(trimmedName)) {
            toast.error('Please Enter Name');
            return;
        }

        // Email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(trimmedEmail)) {
            toast.error('Please enter a valid email address!');
            return;
        }

        // Password length check
        if (trimmedPassword.length < 6) {
            toast.error('Password must be 6 characters!');
            return;
        }

        // Password match check
        if (trimmedPassword !== trimmedConfirmPassword) {
            toast.error('Passwords do not match!');
            return;
        }

        setError("");
        try {
            const data = { name, email, password, confirmpassword };

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/create-user`, data
            );
            // Simulate success
            toast.success('Confirmation Mail sent!');
            setTimeout(() => {
                navigate("/login?registered=1");
            }, 2000);
        } catch (error) {
            console.log("message", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Unable to reach the server");
            }
        }
    };
const logoclick = () => {
    navigate("/home");
}
    return (
        <div
            className="h-screen bg-cover bg-center flex flex-col justify-center items-center text-white text-center px-6"
            style={{ backgroundImage: "url('/images/bg.jpg')" }}>

            <Card className="w-full max-w-[400px]" sx={{ borderRadius: '15px', paddingTop: '10px' }}>
                <div className="flex justify-center">
                    <img src="/images/logo.png" alt="logo" className="max-w-[100px]" 
                    onClick={logoclick} style={{ cursor: 'pointer' }}
                    />
                </div>

                <CardContent sx={{ paddingTop: '0px' }}>
                    <h2 className="text-2xl font-semibold text-center text-[#000]">Registration</h2>

                    <form onSubmit={handleRegister} className="space-y-4 pt-5 pb-0 px-[10px]">
                        <div className="relative">
                            <input 
                                type="text" 
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder=" "
                                id="float_name" 
                                className="block w-full text-sm text-gray-900 bg-transparent rounded-lg border border-[#49bef3] appearance-none dark:border-[#49bef3] focus:outline-none focus:ring-0 focus:border-blue-600 peer dark:focus:border-blue-500" 
                            />
                            <label 
                                htmlFor="float_name" 
                                className="absolute text-sm text-[#49bef3] dark:text-[#49bef3] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                                Name
                            </label>
                        </div>

                        <div className="relative">
                            <input 
                                type="text"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder=""
                                id="float_email" 
                                className="block w-full text-sm text-gray-900 bg-transparent rounded-lg border border-[#49bef3] appearance-none dark:border-[#49bef3] focus:outline-none focus:ring-0 focus:border-blue-600 peer dark:focus:border-blue-500" 
                            />
                            <label 
                                htmlFor="float_email" 
                                className="absolute text-sm text-[#49bef3] dark:text-[#49bef3] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                                Email
                            </label>
                        </div>

                        <div className="relative">
                            <input 
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder=""
                                id="float_password" 
                                className="block w-full text-sm text-gray-900 bg-transparent rounded-lg border border-[#49bef3] appearance-none dark:border-[#49bef3] focus:outline-none focus:ring-0 focus:border-blue-600 peer dark:focus:border-blue-500" 
                            />
                            <label 
                                htmlFor="float_password" 
                                className="absolute text-sm text-[#49bef3] dark:text-[#49bef3] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                                Password
                            </label>
                            <div
                                className="absolute inset-y-0 right-2 flex items-center cursor-pointer"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? <Eye size={18} color='#49bef3' /> : <EyeOff size={18} color='#49bef3' />}
                            </div>
                        </div>

                        <div className="relative">
                            <input 
                                type={showCPassword ? "text" : "password"}
                                value={confirmpassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder=""
                                id="float_cpass" 
                                className="block w-full text-sm text-gray-900 bg-transparent rounded-lg border border-[#49bef3] appearance-none dark:border-[#49bef3] focus:outline-none focus:ring-0 focus:border-blue-600 peer dark:focus:border-blue-500" 
                            />
                            <label 
                                htmlFor="float_cpass" 
                                className="absolute text-sm text-[#49bef3] dark:text-[#49bef3] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                                Confirm Password
                            </label>      
                            <div
                                className="absolute inset-y-0 right-2 flex items-center cursor-pointer"
                                onClick={toggleCPasswordVisibility}
                            >
                                {showCPassword ? <Eye size={18} color='#49bef3' /> : <EyeOff size={18} color='#49bef3' />}
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="w-[150px] flex gap-1 items-center bg-[#49bef3] hover:bg-blue-700 text-white py-[6px] px-6 rounded-[50px] text-base border-2 border-blue-500 justify-center m-auto"
                        >
                            <FileText size={25} />
                            Register
                        </button>
                    </form>
                    
                    <p className="mt-4 text-center text-base">
                        Already have an account?{' '}
                        <a href="/login" className="text-blue-500 hover:underline">
                            Login
                        </a>
                    </p>
                </CardContent>
            </Card>
            <ToastContainer />
        </div>
    );
}